<template>
  <size-charts />
</template>

<script lang="ts" setup>
import SizeCharts from '#commerce/pages/help/size-charts.vue'
</script>
